// Angular
import { Component, AfterContentInit, OnChanges } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { Output, EventEmitter, SimpleChange } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { PRIMARY_OUTLET } from '@angular/router';

// Rx
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { filter } from 'rxjs/operators';

// Services
import { AuthService } from 'app/_services';

// Environment
import { environment } from 'environments/environment';

// 3rd Party
import * as _ from 'underscore';

export interface BreadCrumb {
    label: string;
    url: string;
}

export interface IBreadcrumb {
    label: string;
    params?: Params;
    url: string;
}

@Component({
    selector: 'breadcrumbmenu',
    templateUrl: 'breadcrumbmenu.component.html',
    styleUrls: ['./breadcrumbmenu.component.scss']
})

export class BreadcrumbMenuComponent implements OnInit, AfterContentInit, OnChanges, OnDestroy {
    @Output() change: EventEmitter<any> = new EventEmitter<any>();

    public breadcrumbs: IBreadcrumb[];

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) {
        this.breadcrumbs = [];
    }

    private getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
        const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

        // get the child routes
        const children: ActivatedRoute[] = route.children;

        // return if there are no more children
        if (children.length === 0) {
            return breadcrumbs;
        }

        // iterate over each children
        for (let child of children) {
            // verify primary route
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }

            // verify the custom data property 'breadcrumb' is specified on the route
            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, url, breadcrumbs);
            }

            // get the route's URL segment
            const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

            // append route URL to URL
            url += `/${routeURL}`;

            // add breadcrumb
            const breadcrumb: IBreadcrumb = {
                label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
                params: child.snapshot.params,
                url: url
            };
            breadcrumbs.push(breadcrumb);

            // recursive
            return this.getBreadcrumbs(child, url, breadcrumbs);
        }
    }

    ngAfterContentInit() {
        console.log('BreadcrumbMenuComponent: ngAfterContentInit');
    }

    ngOnInit() {
        console.log('BreadcrumbMenuComponent: ngOnInit');

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            // set breadcrumbs
            const root: ActivatedRoute = this.activatedRoute.root;
            // this.breadcrumbs = this.getBreadcrumbs(root);
        });
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        console.log('BreadcrumbMenuComponent: ngOnChanges');
    }

    ngOnDestroy() {
        console.log('BreadcrumbMenuComponent: ngOnDestroy');
    }
}
